import React from 'react';

import { Button, Heading, Stack, Text } from '@eluve/components';

const FEATURES = [
  'Record as many appointments as you want',
  'Customize your note template',
  'Sync notes to your EHR',
  '30-day free trial — no credit card required',
];

interface WelcomeScreenProps {
  onContinue: () => void;
}

export const WelcomeScreen: React.FC<WelcomeScreenProps> = ({ onContinue }) => {
  return (
    <Stack gap={6} className="p-8">
      <Heading size="4xl" weight="bold">
        Welcome to Eluve!
      </Heading>
      <Stack gap={3}>
        <Text className="text-left">
          Eluve is your AI medical scribe, here to automate your notes and help
          you get your time back.
        </Text>
        {FEATURES.map((feature, index) => (
          <Stack key={index} gap={2} direction="horizontal">
            <Text
              inline
              size="md"
              weight="bold"
              className="size-5 rounded-full leading-5"
            >
              ✓
            </Text>
            <Text inline className="text-left">
              {feature}
            </Text>
          </Stack>
        ))}
      </Stack>

      <Button onClick={onContinue} fullWidth>
        Start using Eluve
      </Button>
    </Stack>
  );
};
